export enum AuthState {
  IDLE = "idle",
  AUTHENTICATING = "authenticating",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
  LOGOUT = "logout",
}

